/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cl_Affects_TranslationInputs */

const en_cl_affects_translation = /** @type {(inputs: Cl_Affects_TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which items count as written in a foreign language, and so can be translated for readers.`)
};

const de_cl_affects_translation = /** @type {(inputs: Cl_Affects_TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welche Elemente als fremdsprachig gelten und deshalb für Lesende übersetzt werden können.`)
};

/**
* | output |
* | --- |
* | "Which items count as written in a foreign language, and so can be translated for readers." |
*
* @param {Cl_Affects_TranslationInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cl_affects_translation = /** @type {((inputs?: Cl_Affects_TranslationInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cl_Affects_TranslationInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cl_affects_translation(inputs)
	return en_cl_affects_translation(inputs)
});